var $tableDep;
var $tableRet;


$(document).ready(function(){
	
	$tableDep = $("#link-table-multi-prov-dep");
	$tableRet = $("#link-table-multi-prov-ret");

});

function refreshTable2(){
	var visibleDepFlightCount = $tableDep.find("tr[data-visible=true][gr=a]").length;
	var visibleRetFlightCount = $tableRet.find("tr[data-visible=true][gr=a]").length;
	
	if(visibleDepFlightCount == 0){
		$(".result_exist_dep").hide();
		$(".result_not_exist_dep").show();
	}else{
		$(".result_exist_dep").show();
		$(".result_not_exist_dep").hide();
	}
	if(visibleRetFlightCount == 0){
		$(".result_exist_ret").hide();
		$(".result_not_exist_ret").show();
	}else{
		$(".result_exist_ret").show();
		$(".result_not_exist_ret").hide();
	}
	
	if(visibleDepFlightCount == 0 && visibleRetFlightCount == 0){
		$(".result_exist_dep").show();
		$(".result_exist_ret").show();
	}	
		
	$tableDep.find("tr[gr=a],tr[gr=b]").hide();
	$tableDep.find("tr[data-visible=true][gr=a]").show();
	
	$tableRet.find("tr[gr=a],tr[gr=b]").hide();
	$tableRet.find("tr[data-visible=true][gr=a]").show();
	
	showPassengers();
	
}